import type { ReactElement } from "react";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@nurion/ui/tooltip";

import { usePortalRoot } from "~/components/EmbedPortalContext";

export function IconTooltip({
  label,
  side = "bottom",
  children,
}: {
  label: string;
  side?: "top" | "right" | "bottom" | "left";
  children: ReactElement;
}): ReactElement {
  const portalContainer = usePortalRoot();
  if (portalContainer === null) return children;
  return (
    <TooltipProvider delayDuration={400}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          portalContainer={portalContainer}
          side={side}
          sideOffset={6}
          collisionPadding={8}
        >
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
